import { Component } from "react";

// Any unexpected intro error skips straight to the hold screen instead of breaking the show.
export default class IntroErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.warn("Intro failed, skipping to hold:", error?.message);
    this.props.onError();
  }

  render() {
    return this.state.failed ? <div data-testid="intro-fallback" /> : this.props.children;
  }
}
